import { gql } from 'src/utils/gql/query';

export const deleteUserNoteGqlMutation = gql`
  mutation ($id: ID!) {
    delete_notes_item(id: $id) {
      id
    }
  }
`;
